import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import "./../node_modules/bootstrap/dist/js/bootstrap.bundle";
import "./../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./../node_modules/jquery/dist/jquery.js";
import Mainpage from "./pages/landing/Mainpage";
import Productlist from "./pages/productList/Productlist"
import Productdetails from "./pages/productDetails/Productdetails";
import Layout from "./components/Layout";
import Mainlayout from "./components/Mainlayout";
import ImageOnLeft from "./components/imageOnLeft/ImageOnLeft";
import ImageOnTop from "./components/imageOnTop/ImageOnTop";
import Compare from "./pages/compare/Compare";
// import { CompareProvider } from "./pages/compare/CompareContext";
import ListView from "./components/listView/ListView";
import "./App.css"
import Configurator from "./pages/Configurator/Configurator.js";
import Cart from "./pages/cart/Cart";
import { CartProvider } from "./store/CartContext";

const App = () => {
  return (

    <CartProvider>
      <Router>
        <Routes>
          {/* Home route */}
          <Route path="/" element={<Mainpage />} />


        {/* Category routes */}
        <Route path="/category/:categoryName" element={<Mainpage />} />

        {/* Product list routes */}
        <Route path="/productlist/:itemName" element={<Productlist />} />


        {/* Product details route */}
        <Route path="/category/:categoryName/productdetails/:itemName" element={<Productdetails />} />


          <Route path="/compare/:categoryName" element={<Compare />} />
          <Route path="/configurator" element={<Configurator/>} />
          <Route path="/cart" element={<Cart />} />

          {/* Layout routes */}

        </Routes>
      </Router>
    </CartProvider>

  );
};

export default App;
